import React from 'react';
import { useLocation } from 'react-router';
import { cartFx, func } from 'utils';
import { _store } from '_Store';
import { useIonRouter } from '@ionic/react';

interface StateProps {
	tabs: {
		path: string;
		icon?: string;
		icon2?: string;
		label?: string;
		component?: any;
	}[];
}
interface Props extends StateProps {}
const Tabs: React.FC<Props> = (props) => {
	const {
		__data: { cart, location, is_bottom_modal },
	} = _store.useState((s) => s);

	const router = useIonRouter();
	const lokation = useLocation();
	const [active, setActive] = React.useState(lokation.pathname.split('/')[1]);

	React.useEffect(() => {
		setActive(lokation.pathname.split('/')[1]);
	}, [lokation.pathname]);

	const navigate = (tab: (typeof props.tabs)[0]) => {
		window.scroll(0, 0);
		router.push(tab.path);
	};

	const hasLocation = !!(
		location.address.iso &&
		location.address.x &&
		location.address.y
	);

	return (
		<React.Fragment>
			{hasLocation && (
				<div
					id="Tabs"
					className={`justify-content-between ${is_bottom_modal.is_open ? 'd-none' : 'd-flex'} ${func.isMobile ? 'isMobile' : ''}`}
				>
					{props.tabs.map((tab) => {
						const isActive = active === tab.path.split('/')[1];
						return (
							<div
								key={tab.path}
								className="text-center"
								onClick={() => navigate(tab)}
								style={{ position: 'relative' }}
							>
								<div>
									<img
										src={isActive ? tab.icon2 : tab.icon}
										alt={tab.path}
										style={{ opacity: isActive ? 1 : 0.6 }}
									/>
									{cart.items.length > 0 && tab.path === '/cart' && (
										<div className="cart_count">
											{cartFx.totalItems(cart.items)}
										</div>
									)}
								</div>
								<div
									className={`small mt-1 ${isActive ? 'primary' : 'text-muted'}`}
									style={{ opacity: isActive ? 1 : 0.6 }}
								>
									{tab.label}
								</div>
							</div>
						);
					})}
				</div>
			)}
		</React.Fragment>
	);
};

export default Tabs;

export const Offset = () => (
	<div
		id="TabsOffset"
		className={`${func.isMobile ? 'isMobile' : ''} hide`}
		style={{ marginTop: '7vh' }}
	/>
);
